export default __webpack_public_path__ + "static/media/ftb.5b1a147f.svg";